import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["accept"]

import { ref } from "vue";
import { useToast } from "vue-toastification";


export default /*@__PURE__*/_defineComponent({
  __name: 'FileUpload',
  props: {
    accept: {},
    method: {}
  },
  emits: ["loaded"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const toast = useToast();
const fileInput = ref<HTMLElement | null>(null);

const onUpload = (e: InputEvent) => {
  if (e?.target == null) return;
  if (e.target.files.length < 1) throw Error("No file has been uploaded");

  const file = e.target.files[0];

  const reader = new FileReader();
  reader.addEventListener("error", () => {
    toast.error("Failed to read the file");
  });
  reader.addEventListener("load", () => {
    emit("loaded", file, reader.result);
  });

  reader[props.method](file);
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (fileInput.value?.click())),
    class: "btn btn-neutral"
  }, [
    _createElementVNode("input", {
      type: "file",
      class: "hidden",
      ref_key: "fileInput",
      ref: fileInput,
      accept: _ctx.accept,
      onInput: onUpload
    }, null, 40, _hoisted_1),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createVNode(_component_Icon, {
        icon: "ic:baseline-upload",
        class: "text-lg"
      })
    ])
  ]))
}
}

})